var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11C21 16.5224 16.5228 21 11 21C5.47721 21 1 16.5224 1 11C1 5.47757 5.47721 1 11 1C16.5228 1 21 5.47757 21 11Z",
    fill: "white",
    stroke: "#575757",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 10.973C8.06953 10.8945 9.93464 10.8609 11.2174 11.5553C12.6537 12.3328 12.6816 13.3123 13.4491 15.8739",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5.99197C8.79326 5.85365 11.9291 6.09198 12.1272 8.15086C12.3746 10.7256 9.1514 10.9742 7.25 10.9742",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 5.99219H14.5291M7.17188 8.48286H14.5291",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.57f05eaa70f0feb503d0eb386237e05f.svg";
export { ForwardRef as ReactComponent };